import React from 'react';
import './MScInAccountingAndFinance.css'; // Optional: Create a CSS file for styling

const BScInComputerScience = () => {
  return (
    <div className="msc-container" style={{ padding: '20px', maxWidth: '800px', marginTop: '160px',marginLeft:'70px' }}>
      <h1 style={{ textAlign: 'center' }}>📘 Bachelor of Science in Computer Science</h1>

      <section>
        <h2 style={{ textAlign: 'center' }}>Program Overview</h2>
        <p>
          The BSc in Computer Science program at Admas University offers a strong foundation in software development, algorithms, artificial intelligence, data structures, computer networks, and cybersecurity. The program is tailored to prepare students for real-world challenges and innovations in the tech industry.
        </p>
      </section>

      <section>
        <h2>🎓 Program Objectives</h2>
        <ul>
          <li>To provide students with theoretical and practical knowledge in computer science.</li>
          <li>To equip graduates with problem-solving and programming skills to build innovative solutions.</li>
          <li>To foster research, ethics, and professionalism in the computing field.</li>
          <li>To prepare students for further studies and careers in software engineering, AI, and IT systems.</li>
        </ul>
      </section>

      <section>
        <h2>📚 Core Courses</h2>
        <ul>
          <li>Introduction to Programming (Python, Java)</li>
          <li>Data Structures and Algorithms</li>
          <li>Database Management Systems</li>
          <li>Operating Systems</li>
          <li>Computer Networks</li>
          <li>Software Engineering</li>
          <li>Web Development</li>
          <li>Cybersecurity</li>
          <li>Artificial Intelligence & Machine Learning</li>
          <li>Mobile Application Development</li>
        </ul>
      </section>

      <section>
        <h2>🎓 Admission Requirements</h2>
        <ul>
          <li>Completion of Ethiopian Higher Education Entrance Certificate (Grade 12 national exam).</li>
          <li>TVET Level IV graduates with a COC certificate may apply through a bridging program.</li>
          <li>Transfer students from accredited institutions are eligible per university policy.</li>
        </ul>
      </section>

      <section>
        <h2>🧭 Career Opportunities</h2>
        <p>
          Graduates of the Computer Science program can work as software developers, system analysts, network administrators, cybersecurity specialists, AI developers, database administrators, and IT consultants across industries.
        </p>
      </section>

      <section>
        <h2>🏛️ Why Choose Admas University?</h2>
        <ul>
          <li>Modern computer labs and hands-on project-based learning.</li>
          <li>Experienced faculty and industry-relevant curriculum.</li>
          <li>Internship and industry linkage programs.</li>
          <li>Flexible schedules: regular, evening, and weekend classes.</li>
          <li>Nationwide campuses with consistent quality education.</li>
        </ul>
      </section>
    </div>
  );
};

export default BScInComputerScience;